import { LocaleSelector } from "@/components/features/profiles/locale-selector"
import { TimeZoneSelector } from "@/components/features/profiles/time-zone-selector"
import { AdminLayout } from "@/components/layouts/admin-layout"
import { MainContainer } from "@/components/ui/container"
import { TimeZoneOption } from "@/lib/time-zone"

type Props = {
  timeZone: string
  timezones: TimeZoneOption[]
}

export default function AdminProfilesSettings({ timeZone, timezones }: Props) {
  return (
    <AdminLayout>
      <MainContainer size="xs">
        <div data-testid="profile-settings-view">
          <LocaleSelector />
          <TimeZoneSelector timeZone={timeZone} timezones={timezones} />
        </div>
      </MainContainer>
    </AdminLayout>
  )
}
